import React from 'react';
import SingleSelect from './single_select';
import MultiSelect from './multi_select';
import { QuestionType } from '../../models/questionnaire.interface';
import { InteractionUserResponses } from 'models/interactions.interface';

interface QuestionOptionsProps extends QuestionType {
  isBeingEdited: boolean;
  disabled: boolean;
  selectedAnswers?: InteractionUserResponses['answers'];
}
const QuestionOptions: React.FC<QuestionOptionsProps> = ({
  answers,
  type,
  id: questionId,
  isBeingEdited,
  disabled,
  selectedAnswers,
}) => {
  const mappedAnswers = answers.map((answer) => {
    return { label: answer.text, value: answer.id };
  });

  const renderOptions = () => {
    switch (type) {
      case 'select':
        return (
          <SingleSelect
            answers={mappedAnswers}
            rawAnswers={answers}
            questionId={questionId}
            disabled={disabled}
            selectedAnswers={selectedAnswers}
          />
        );
      case 'multiselect':
        return (
          <MultiSelect
            answers={mappedAnswers}
            rawAnswers={answers}
            questionId={questionId}
            isBeingEdited={isBeingEdited}
            disabled={disabled}
            selectedAnswers={selectedAnswers}
          />
        );
      case 'freeText':
        return null;
      default:
        return;
    }
  };

  return renderOptions()
    ? (
        <div style={{ marginTop: '12px' }}>{renderOptions()}</div>
      )
    : (
        <></>
      );
};

export default QuestionOptions;
